import React, { useState, useEffect, useRef } from "react";
import "./domain.css";

import Healthcare1 from "../Assets/healthcare1.png";
import Box4 from "../Assets/box-4.png";
import Box5 from "../Assets/box-5.png";
import Box6 from "../Assets/box-6.png";

import { useStateContext } from "../contexts/ContextProvider";
import DomainBanner from "./DomainBanner";

const Healthcare = () => {
  const title = "Healthcare";
  const body =
    "In the dynamic world of retail, where customer preferences evolve rapidly and competition is fierce, empowering your team with the right skills is essential for success. Our tailored digital upskilling solutions meet the unique demands of transportation and logistics, ensuring excellence and compliance. From product knowledge to customer service, we equip your team for success.";

  const { handleShowContact } = useStateContext();

  const [play, setPlay] = useState(false);

  const vidRef = useRef(null);

  const handlePlay = () => {
    setPlay(true);
    if (vidRef && vidRef.current) {
      if (vidRef.current.paused) {
        setPlay(true);
        vidRef.current.play();
      } else {
        setPlay(false);
        vidRef.current.pause();
      }
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional, for animated scrolling
    });
  }, []);
  return (
    <>
      <DomainBanner domain="healthcare" title={title} body={body} />
      <div className="domain-section">
        <div className="domain-container domain-text">
          <p>
            Traditional training is rigid and time-consuming, creating knowledge
            gaps that impact patient care. Fidus offers flexible, accessible
            learning that fits your schedule.
          </p>
        </div>
      </div>
      <div className="domain-section">
        <div className="heading-flex">
          <h3>This is where e-Training shines!</h3>
        </div>
      </div>

      <div className="domain-section">
        <div className="domain-container">
          <div className="domain-features">
            <div className="row">
              <div className="col-lg-4">
                <div className="box-new box1">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box4} className="img-fluid" alt="" />
                    </div>
                    <div className="content">
                      <h3><span>Effortless</span> Scalability</h3>
                      <p>
                        Keep your workforce equipped with the latest information
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="box-new box2">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box5} className="img-fluid" alt="" />
                    </div>
                    <div className="content">
                      <h3><span>Standardized</span> Excellence</h3>
                      <p>Consistent knowledge and skillsets</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="box-new box3">
                  <div className="box-cover">
                    <div className="img">
                      <img src={Box6} className="img-fluid" alt="" />
                    </div>
                    <div className="content">
                      <h3><span>Unparalleled</span> Flexibility</h3>
                      <p>Freedom to learn anytime, anywhere</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="domain-section">
        <div className="domain-container">
          <div className="domain-features2">
            <div className="domain-text">
              <h3>Engaging <span>Learning</span> Experiences</h3>
              <p>
                Gone are the days of monotonous lectures! We believe in making
                learning interactive and immersive. Our eTraining modules
                incorporate:
              </p>
            </div>
            <div className="domain-text">
              <div className="row">
                <div className="col-lg-3 col-6">
                  <div className="domain-text-flex">
                    <span className="icon">
                      <svg
                        width="60"
                        height="61"
                        viewBox="0 0 60 61"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M30.0587 23.5541C33.6179 23.5541 36.4881 20.6837 36.4881 17.1247C36.4881 13.5657 33.6406 10.6953 30.0587 10.6953C26.4995 10.6953 23.6293 13.5657 23.6293 17.1247C23.652 20.7069 26.5224 23.5541 30.0587 23.5541ZM15.1332 42.1766H3.58322C-0.159517 42.1766 -0.366236 36.459 3.65212 36.459H13.6635L19.404 28.0088C21.1032 25.6897 23.0321 24.5874 25.7645 24.5874H34.3295C37.062 24.5874 38.9907 25.5978 40.6899 28.0088L46.4534 36.459H56.5339C60.5752 36.459 60.3226 42.1766 56.6717 42.1766H45.1217C44.2032 42.1766 43.101 41.855 42.4581 40.8678L38.0492 34.5763L38.0263 50.3284H22.2285L22.2055 34.5763L17.7967 40.8678C17.1538 41.832 16.0517 42.1766 15.1332 42.1766Z"
                          fill="#05A9A6"
                        />
                        <path
                          d="M9.14039 23.5482C9.14039 22.9316 9.64453 22.4277 10.2609 22.4277C10.8776 22.4277 11.3815 22.9318 11.3815 23.5482C11.3815 24.1648 10.8872 24.6687 10.2609 24.6687C9.63937 24.6687 9.14039 24.1648 9.14039 23.5482ZM12.9966 20.7734V31.7891L0.46875 31.7841V20.7734H12.9966ZM12.2477 21.5368H1.23703V29.6309L4.60383 23.2252L6.89906 27.923L9.17953 26.4207L12.248 29.3323L12.2477 21.5368Z"
                          fill="#05A9A6"
                        />
                        <path
                          d="M58.0078 24.013V25.4844C58.0078 27.7362 56.306 29.5787 54.1181 29.8473V31.6002L55.4616 32.739H56.063V33.4299H54.2077H53.6063H50.5484V32.739H51.1624L52.4674 31.6386V29.8346C50.2924 29.5531 48.6035 27.7107 48.6035 25.4717V24.0132H49.4351V25.4717C49.4351 27.4421 51.0345 29.0541 53.0175 29.0541H53.5934C55.5638 29.0541 57.1758 27.4548 57.1758 25.4717V24.0132L58.0078 24.013ZM54.4765 25.2542V24.4098H56.2294V23.3094H54.4765V22.4776H56.2294V21.3772H54.4765V20.5327H56.2165C56.1654 19.1124 55.001 17.9609 53.568 17.9609H53.0306C51.5977 17.9609 50.4333 19.1124 50.3948 20.5327H52.0709V21.3772H50.382V22.4776H52.0709V23.322H50.382V24.4224H52.0709V25.2669H50.382V25.3438C50.382 26.7896 51.5719 27.9795 53.0304 27.9795H53.5678C55.0263 27.9795 56.2163 26.7896 56.2163 25.3311V25.2542H54.4765Z"
                          fill="#05A9A6"
                        />
                      </svg>
                    </span>
                    <span className="txt">Interactive Elements</span>
                  </div>
                </div>
                <div className="col-lg-3 col-6">
                  <div className="domain-text-flex">
                    <span className="icon">
                      <svg
                        width="60"
                        height="61"
                        viewBox="0 0 60 61"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_1736_8243)">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M54 27.5C54 25.844 52.656 24.5 51 24.5H9C7.344 24.5 6 25.844 6 27.5V51.5C6 53.156 7.344 54.5 9 54.5H15C16.656 54.5 18 53.156 18 51.5C18 49.844 19.344 48.5 21 48.5H39C40.656 48.5 42 49.844 42 51.5C42 53.156 43.344 54.5 45 54.5H51C52.656 54.5 54 53.156 54 51.5V27.5ZM60 24.5V54.5C60 57.815 57.315 60.5 54 60.5H42C38.685 60.5 36 57.815 36 54.5H24C24 57.815 21.315 60.5 18 60.5H6C2.685 60.5 0 57.815 0 54.5V24.5C0 21.185 2.685 18.5 6 18.5H27V12.5C27 9.185 29.685 6.5 33 6.5H39C40.656 6.5 42 5.156 42 3.5V0.5H48V6.5C48 9.815 45.315 12.5 42 12.5H36C34.344 12.5 33 13.844 33 15.5V18.5H54C57.315 18.5 60 21.185 60 24.5ZM45 30.5H39C37.344 30.5 36 31.844 36 33.5V36.5V39.5C36 41.156 37.344 42.5 39 42.5H45C46.656 42.5 48 41.156 48 39.5V36.5V33.5C48 31.844 46.656 30.5 45 30.5ZM24 33.5V36.5V39.5C24 41.156 22.656 42.5 21 42.5H15C13.344 42.5 12 41.156 12 39.5V36.5V33.5C12 31.844 13.344 30.5 15 30.5H21C22.656 30.5 24 31.844 24 33.5Z"
                            fill="#05A9A6"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1736_8243">
                            <rect
                              width="60"
                              height="60"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <span className="txt">Gamification</span>
                  </div>
                </div>
                <div className="col-lg-3 col-6">
                  <div className="domain-text-flex">
                    <span className="icon">
                      <svg
                        width="69"
                        height="69"
                        viewBox="0 0 69 69"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g opacity="0.2">
                          <path
                            d="M34.498 15.0918C12.9355 15.0918 4.31055 34.5002 4.31055 34.5002C4.31055 34.5002 12.9355 53.9043 34.498 53.9043C56.0605 53.9043 64.6855 34.5002 64.6855 34.5002C64.6855 34.5002 56.0605 15.0918 34.498 15.0918ZM34.498 45.2815C32.3657 45.2815 30.2813 44.6492 28.5083 43.4646C26.7353 42.2799 25.3535 40.5961 24.5375 38.6261C23.7215 36.6561 23.508 34.4883 23.924 32.397C24.34 30.3056 25.3668 28.3846 26.8746 26.8768C28.3823 25.369 30.3034 24.3422 32.3947 23.9262C34.4861 23.5102 36.6538 23.7237 38.6239 24.5397C40.5939 25.3557 42.2777 26.7376 43.4623 28.5105C44.647 30.2835 45.2793 32.368 45.2793 34.5003C45.2793 37.3596 44.1434 40.1019 42.1215 42.1238C40.0997 44.1456 37.3574 45.2815 34.498 45.2815Z"
                            fill="#05A9A6"
                          />
                        </g>
                        <path
                          d="M66.6559 33.624C66.5611 33.411 64.2788 28.3476 59.2025 23.271C52.4416 16.5092 43.8987 12.9351 34.498 12.9351C25.0973 12.9351 16.5544 16.5092 9.79349 23.271C4.71714 28.3476 2.43482 33.411 2.34006 33.624C2.21758 33.8997 2.1543 34.198 2.1543 34.4997C2.1543 34.8013 2.21758 35.0997 2.34006 35.3754C2.43482 35.5886 4.71741 40.6507 9.79376 45.7265C16.5547 52.4867 25.0973 56.0601 34.498 56.0601C43.8987 56.0601 52.4413 52.4867 59.2022 45.7265C64.2786 40.6507 66.5611 35.5886 66.6559 35.3754C66.7784 35.0997 66.8417 34.8014 66.8417 34.4997C66.8417 34.198 66.7784 33.8997 66.6559 33.624ZM34.498 51.7476C26.2017 51.7476 18.9531 48.7327 12.9531 42.7867C10.4873 40.3397 8.3889 37.5483 6.72337 34.4997C8.38881 31.4503 10.4872 28.6583 12.9531 26.2105C18.9531 20.2632 26.202 17.2476 34.498 17.2476C42.794 17.2476 50.0429 20.2632 56.0429 26.2105C58.509 28.6583 60.6074 31.4504 62.2729 34.4999C60.3288 38.1252 51.8643 51.7476 34.498 51.7476Z"
                          fill="#05A9A6"
                        />
                        <path
                          d="M34.4981 21.5625C31.9393 21.5625 29.4379 22.3213 27.3104 23.7429C25.1828 25.1645 23.5246 27.185 22.5454 29.549C21.5662 31.9131 21.3099 34.5144 21.8091 37.024C22.3083 39.5336 23.5405 41.8389 25.3499 43.6482C27.1592 45.4575 29.4644 46.6897 31.9741 47.1889C34.4837 47.6881 37.085 47.4319 39.449 46.4527C41.813 45.4735 43.8336 43.8153 45.2552 41.6877C46.6768 39.5601 47.4356 37.0588 47.4356 34.5C47.4317 31.0699 46.0674 27.7815 43.642 25.356C41.2166 22.9306 37.9281 21.5663 34.4981 21.5625ZM34.4981 43.125C32.7922 43.125 31.1246 42.6192 29.7063 41.6714C28.2879 40.7237 27.1824 39.3767 26.5296 37.8006C25.8768 36.2246 25.706 34.4904 26.0388 32.8173C26.3716 31.1443 27.193 29.6074 28.3993 28.4012C29.6055 27.195 31.1423 26.3735 32.8154 26.0407C34.4885 25.7079 36.2227 25.8787 37.7987 26.5315C39.3747 27.1843 40.7218 28.2898 41.6695 29.7082C42.6172 31.1266 43.1231 32.7941 43.1231 34.5C43.1204 36.7867 42.2109 38.979 40.594 40.5959C38.977 42.2128 36.7847 43.1224 34.4981 43.125Z"
                          fill="#05A9A6"
                        />
                      </svg>
                    </span>
                    <span className="txt">Realistic Simulations</span>
                  </div>
                </div>
                <div className="col-lg-3 col-6">
                  <div className="domain-text-flex">
                    <span className="icon">
                      <svg
                        width="60"
                        height="61"
                        viewBox="0 0 60 61"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_1736_8258)">
                          <path
                            d="M30 57.5C44.9117 57.5 57 45.4117 57 30.5C57 15.5883 44.9117 3.5 30 3.5C15.0883 3.5 3 15.5883 3 30.5C3 45.4117 15.0883 57.5 30 57.5Z"
                            stroke="#05A9A6"
                            strokeWidth="6"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M23.9942 19.7826L40.4709 29.1978C41.1901 29.6088 41.44 30.5251 41.029 31.2444C40.8961 31.4769 40.7034 31.6697 40.4709 31.8026L23.9942 41.2178C23.2749 41.6288 22.3587 41.3789 21.9476 40.6596C21.8181 40.433 21.75 40.1765 21.75 39.9154V21.085C21.75 20.2565 22.4216 19.585 23.25 19.585C23.511 19.585 23.7676 19.6531 23.9942 19.7826Z"
                            fill="#05A9A6"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1736_8258">
                            <rect
                              width="60"
                              height="60"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </span>
                    <span className="txt">Multimedia Resources</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="domain-section">
        <div className="domain-container">
          <div className="domain-bg domain-bg2">
            <h3>Measurable Results for Continuous Improvement</h3>
            <p>
              Unlike traditional training methods, eTraining offers
              comprehensive performance tracking. Monitor learner progress,
              identify areas needing improvement, and tailor training programs
              to address specific knowledge gaps within your healthcare team.
            </p>
          </div>
        </div>
      </div>
      <div className="domain-section">
        <div className="domain-container">
          <p className="domain-text3">
            Ready to revolutionize healthcare training? Contact us today and
            let's discuss how our eTraining solutions can empower your
            healthcare professionals!
          </p>
        </div>
      </div>
      <div className="cta">
        <div className="cta-flex" onClick={handleShowContact}>
         <h4>Let's Get In Touch</h4>
          <svg
            width="46"
            height="47"
            viewBox="0 0 46 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.417 33.0834L32.5837 13.9167M32.5837 13.9167H15.3337M32.5837 13.9167V31.1668"
              stroke="#15ADAA"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default Healthcare;
